import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import UserLayout from "../../components/user/UserLayout";
import { useParams, Link } from "react-router-dom";
import {
  Card,
  Carousel,
  Spinner,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import { FaArrowLeft, FaFlask } from "react-icons/fa";

const DiseaseDetailPage = () => {
  const { id } = useParams();
  const [disease, setDisease] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadDisease = async () => {
    try {
      const res = await api.get(`/diseases/${id}`);
      setDisease(res.data);
    } catch (err) {
      console.error("Hastalık alınamadı:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDisease();
  }, [id]);

  if (loading)
    return (
      <UserLayout>
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      </UserLayout>
    );

  if (!disease)
    return (
      <UserLayout>
        <p>Hastalık bulunamadı.</p>
      </UserLayout>
    );

  return (
    <UserLayout>

      {/* BAŞLIK */}
      <h2 className="fw-bold mb-2" style={{ color: "#2D8A7A" }}>
        {disease.name}
      </h2>

      <div
        style={{
          height: "3px",
          width: "80px",
          backgroundColor: "#2D8A7A",
          borderRadius: "5px",
          marginBottom: "15px",
        }}
      ></div>

      {/* GERİ DÖN — başlığın altına taşındı */}
      <Button
        as={Link}
        to="/panel/diseases"
        variant="outline-primary"
        className="rounded-pill mb-4"
      >
        <FaArrowLeft className="me-2" /> Tüm Hastalıklara Dön
      </Button>

      <Row className="g-4">
        {/* SOL TARAF */}
        <Col md={7}>
          {/* Slider */}
          {disease.imageUrls?.length > 0 ? (
            <Carousel className="shadow-sm rounded-4 overflow-hidden">
              {disease.imageUrls.map((img, i) => (
                <Carousel.Item key={i}>
                  <img
                    src={img}
                    className="d-block w-100"
                    style={{
                      maxHeight: "420px",
                      objectFit: "cover",
                    }}
                    alt={`img-${i}`}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <Card className="p-5 text-center text-muted">
              Görsel bulunmuyor
            </Card>
          )}

          {/* Açıklama */}
          <Card className="p-4 shadow-sm rounded-4 mt-4">
            <h5 className="fw-bold" style={{ color: "#2D8A7A" }}>
              Hastalık Hakkında
            </h5>
            <p
              className="text-muted mt-2"
              style={{ fontSize: "1.05rem", lineHeight: "1.7" }}
            >
              {disease.description}
            </p>
          </Card>
        </Col>

        {/* SAĞ TARAF */}
        <Col md={5}>
          <div style={{ position: "sticky", top: "100px" }}>
            {/* İlgili Formüller */}
            <Card className="p-4 shadow-sm rounded-4 mb-4">
              <h5 className="fw-bold mb-3 d-flex align-items-center">
                <FaFlask className="me-2 text-primary" /> İlgili Formüller
              </h5>

              {disease.relatedFormulas.length === 0 && (
                <p className="text-muted">Bu hastalığa bağlı formül bulunmuyor.</p>
              )}

              {disease.relatedFormulas.map((formula) => (
                <Card key={formula._id} className="p-3 mb-3 shadow-sm rounded-3">
                  <h6 className="fw-bold mb-1">
                    {formula.formulationName || "Başlık bulunamadı"}
                  </h6>

                  <Button
                    as={Link}
                    to={`/formul/${formula._id}`}
                    variant="primary"
                    size="sm"
                    className="mt-2"
                  >
                    İncele
                  </Button>
                </Card>
              ))}
            </Card>

            {/* ⭐ REKLAM ALANI — artık İÇTE DEĞİL, dışarıda alt kısımda */}
            <Card
              className="p-4 shadow-sm rounded-4 text-center"
              style={{
                background: "#f8fafc",
                border: "2px dashed #cdd6dd",
              }}
            >
              <h6 className="fw-bold mb-2">Reklam Alanı</h6>
              <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                Bu alana reklam verebilirsiniz, bizimle iletişime geçin.
              </p>
            </Card>
          </div>
        </Col>
      </Row>
    </UserLayout>
  );
};

export default DiseaseDetailPage;
